import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ValidatorFn, AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { formatRut, RutFormat } from '@fdograph/rut-utilities';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MyValidators } from 'src/app/libs/my-validators';
import { ApiService } from 'src/app/services/api.service';
import { ApiEntryControlService } from '../../../api-entry-control.service';
import { Employees } from '../../../interfaces/employees';
import { Providers } from '../../../interfaces/providers';
export function atLeastOneDaySelectedValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    const days = control.get('days')?.value as string[];
    if (days && days.length > 0) {
      return null; // La validación pasa si al menos un día está seleccionado
    } else {
      return { atLeastOneDaySelected: true }; // La validación falla si ningún día está seleccionado
    }
  };
}
@Component({
  selector: 'app-edit-providers',
  templateUrl: './edit-providers.component.html',
  styleUrls: ['./edit-providers.component.css']
})
export class EditProvidersComponent implements OnInit, OnChanges {
  constructor(
    private api: ApiEntryControlService,
    private apiFull: ApiService,
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    private modal: NgbModal
  ) { }
  ngOnInit(): void {
    this.getState();
    if (this.providers != null) {
      this.get(this.providers);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.providers?.id > 0) {
      this.get(this.providers);
    }
  }
  @Output()
  success = new EventEmitter<boolean>();
  @Input()
  providers: Providers;
  items: any;
  allDays: string[] = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
  form1: FormGroup = this.formBuilder.group({
    id: [],
    name: ['', Validators.required],
    lastname: [''],
    rut: ['', [Validators.required, MyValidators.rut]],
    email: [''],
    phone: [''],
    company:[''],
    cars_type: [0],
    cars_ppu: [''],
    state_id: [0],
    stores_id: [0],
    days: [''],
    xdays: [[]],
    selday:[1],
    date_ing:[]
  }, { validators: atLeastOneDaySelectedValidator() });
  cars: string[] = [
    'Automovil',
    'Camioneta',
    'Camión',
    'Furgón',
    'St. Wagón',
    'Motocicleta',
    'Otro'
  ];
  get(item: Employees) {
    this.api.getProvider(item?.id).subscribe((res) => {
      let data = res.data as Employees;
      this.form1.patchValue(res.data);
      this.form1.get('rutview')?.setValue(data?.rut);
      // Dividir la cadena de días en un arreglo de días seleccionados
      const selectedDays = data.days.split(',');

      // Asignar los días seleccionados al control "xdays" del formulario
      this.form1.get('xdays')?.setValue(selectedDays);
    }, error => {
      this.toast.warning(error.error.mistakes, error.error.msg, { enableHtml: true, closeButton: true });
      this.modal.dismissAll();
    });
  }
  getState() {
    this.apiFull.getState().subscribe((res) => {
      this.items = res.data;
    });
  }

  onFormatRut(value: any) {
    if (value.target.value.length > 8) {
      this.form1
        .get('rut')
        ?.setValue(formatRut(value.target.value, RutFormat.DOTS_DASH));
    }
  }
  update() {
    const selectedDays = this.form1.value.xdays as string[];
    const daysString = selectedDays ? selectedDays.join(',') : '';
    this.form1?.get('days')?.setValue(daysString);
    this.api.updateProviders(this.form1).subscribe(
      (response) => {
        this.toast.success(response.msg, 'Proveedores');
        this.success.emit(true);
        this.modal.dismissAll();
      },
      (err) => {
        this.toast.warning(err.error.mistakes, err.error.msg, { enableHtml: true, closeButton: true });
      }
    );
  }

  openModal(md: any, size = 'md') {
    this.modal.open(md, {
      size: 'xl',
    });
  }
  toggleDaySelection(day: string): void {
    const xdaysControl = this.form1.get('xdays');
  
    const currentValue = xdaysControl.value || [];
    const selectedIndex = currentValue.indexOf(day);
  
    if (selectedIndex === -1) {
      // Si el día no está seleccionado, agrégalo
      currentValue.push(day);
    } else {
      // Si el día está seleccionado, retíralo
      currentValue.splice(selectedIndex, 1);
    }
  
    xdaysControl.setValue(currentValue);
  }
  
}
